import { render, staticRenderFns } from "./CreateUpdateOrganization.vue?vue&type=template&id=5652d425&"
import script from "./CreateUpdateOrganization.vue?vue&type=script&lang=js&"
export * from "./CreateUpdateOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports